import { render, staticRenderFns } from "./AiProductRequests.vue?vue&type=template&id=57e506eb&scoped=true"
import script from "./AiProductRequests.vue?vue&type=script&lang=js"
export * from "./AiProductRequests.vue?vue&type=script&lang=js"
import style0 from "./AiProductRequests.vue?vue&type=style&index=0&id=57e506eb&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e506eb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/dev.ideabuddy.com/public_html/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57e506eb')) {
      api.createRecord('57e506eb', component.options)
    } else {
      api.reload('57e506eb', component.options)
    }
    module.hot.accept("./AiProductRequests.vue?vue&type=template&id=57e506eb&scoped=true", function () {
      api.rerender('57e506eb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Home/AiAssistance/Components/AiProductRequests.vue"
export default component.exports